var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightBlurNoUserButton001(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 99 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f5f5f5;}.b{fill:#d7d7d7;}.c{fill:#e0e0e0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 918.461975, 234.169998)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-918.462 -234.17)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-918.462 -234.17)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M86.5,28.5h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.489,34.5h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M81.683,22.5H77.739v-1h3.944Zm-9.944,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M76.544,40.5h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M76.417,16.5H72.584v-1h3.833Zm-9.833,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M66.139,46.5h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M66.348,10.5h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Zm-10,0h-4v-1h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M56.41,52.5h-4v-1h4Zm-10,0h-4v-1h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M56.471,4.5h-4v-1h4Zm-10,0h-4v-1h4Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBlurNoUserButton001);
export default __webpack_public_path__ + "light-blur-no-user-button-001.5a252d95a8e3b087465e709f3b1d9270.svg";
export { ForwardRef as ReactComponent };